<form class="form-inline">
    <div class="search-input-wrapper">
		<label for="field-value" class="sr-only">{{locale "searchValue"}}</label>
		<input type="text" id="field-value" name="field-value" value="{{ value }}" class="form-control"/>
    </div>
    <button type="button" class="close" data-control="removeFilter">{{icon name="close" locale="clearFilter"}}</button>
    <button type="submit" name="submit" class="btn btn-sm btn-primary" disabled="disabled">{{locale "apply"}}</button>
    <button type="button" name="clear" class="btn btn-sm btn-tertiary btn-clear-filter hidden">{{locale "clear"}}</button>
</form>